import {
  faBolt,
  faBrain,
  faBuildingShield,
  faLayerGroup,
  faLaptopCode,
  faListCheck,
  faSitemap,
} from '@fortawesome/free-solid-svg-icons';

/** Программа с листа «Для сайта» (три специализации). */
export const PROGRAM_SUBTITLE =
  'Сбалансированная траектория: стратегия → практика внедрения → доверие/этика/регуляторика → разработка и валидация.';

export const PROGRAM_TRACKS = [
  {
    id: 'doctors',
    audienceLabel: 'Врачи',
    modules: [
      {
        id: 1,
        title: 'Основы ИИ. Ландшафт ИИ в здравоохранении',
        icon: faBrain,
        points: [
          '1.1. Основы ИИ в здравоохранении',
          '1.2. НПА. Ландшафт применения ИИ в здравоохранении.',
          '1.3. Большие языковые модели',
          '1.4. Обзор мировых трендов',
          '1.5. Прогнозная аналитика',
        ],
      },
      {
        id: 2,
        title: 'Особенности применения медицинских и немедицинских изделий в ИИ',
        icon: faLayerGroup,
        points: [
          '2.1. Внедрение ИИ, направленных на обработку ЭМК',
          '2.2. Внедрение ИИ, направленных на обработку изображений',
          '2.3. Внедрение ИИ, направленных на расшифровку данных видеопотока. Применение ИИ в колонопроктологии',
          '2.4. Внедрение ИИ, направленных на расшифровку данных ЭКГ',
          '2.5. Применение сервисов видеоаналитики',
          '2.6. Применение чат-ботов',
        ],
      },
      {
        id: 3,
        title: 'Инцидент И11. Сценарии внедрения ИИ. Методика расчёта показателей модели зрелости И11',
        icon: faListCheck,
        points: [
          '3.1. Сценарии внедрения ИИ, направленных на обработку изображений',
          '3.2. Сценарии внедрения ИИ, направленных на расшифровку данных ЭМК.',
        ],
      },
      {
        id: 4,
        title: 'Этические вопросы применения ИИ в здравоохранении',
        icon: faBuildingShield,
        points: ['4.1. Этика применения ИИ в здравоохранении'],
      },
    ],
  },
  {
    id: 'organizers',
    audienceLabel: 'Организаторы',
    modules: [
      {
        id: 1,
        title: 'Основы ИИ. Ландшафт ИИ в здравоохранении',
        icon: faBrain,
        points: [
          '1.1. Основы ИИ в здравоохранении',
          '1.2. НПА. Ландшафт применения ИИ в здравоохранении.',
          '1.3. Большие языковые модели',
          '1.4. Обзор мировых трендов',
          '1.5. Прогнозная аналитика',
        ],
      },
      {
        id: 2,
        title: 'Особенности применения медицинских и немедицинских изделий в ИИ',
        icon: faLayerGroup,
        points: [
          '2.1. Внедрение ИИ, направленных на обработку ЭМК',
          '2.2. Внедрение ИИ, направленных на обработку изображений',
          '2.3. Внедрение ИИ, направленных на расшифровку данных видеопотока. Применение ИИ в колонопроктологии',
          '2.4. Внедрение ИИ, направленных на расшифровку данных ЭКГ',
          '2.5. Применение сервисов видеоаналитики',
          '2.6. Применение чат-ботов',
        ],
      },
      {
        id: 3,
        title:
          'Внедрение ИИ в процессы оказания медицинской помощи. Сценарии внедрения. Региональные практики',
        icon: faSitemap,
        points: [
          '3.1. Настройка инфраструктуры ГИС СЗ, ЦАМИ',
          '3.2. Инвентаризация ФРМО и ФРМР',
          '3.3. Московский эксперимент по компьютерному зрению в лучевой диагностике',
        ],
      },
      {
        id: 4,
        title: 'Инцидент И11. Сценарии внедрения ИИ. Методика расчёта показателей модели зрелости И11',
        icon: faBolt,
        points: [
          '4.1. Показатели Инцидента и способы их достижения. Показатели модели зрелости инцидента И11',
          '4.2. Сценарии внедрения ИИ, направленных на обработку изображений и ЭМК',
        ],
      },
      {
        id: 5,
        title: 'Этические вопросы применения ИИ в здравоохранении',
        icon: faBuildingShield,
        points: ['5.1. Этика применения ИИ в здравоохранении'],
      },
    ],
  },
  {
    id: 'it',
    audienceLabel: 'ИТ-специалисты',
    modules: [
      {
        id: 1,
        title:
          'Внедрение ИИ в процессы оказания медицинской помощи. Сценарии внедрения. Региональные практики',
        icon: faSitemap,
        points: [
          '1.1. Настройка инфраструктуры ГИС СЗ, ЦАМИ',
          '1.2. Инвентаризация ФРМО и ФРМР',
          '1.3. Алгоритм разворачивания локальных ИИ решений',
          '1.4. Алгоритм подключения к МосМедИИ',
        ],
      },
      {
        id: 2,
        title: 'Инцидент И11. Сценарии внедрения ИИ. Методика расчёта показателей модели зрелости И11',
        icon: faBolt,
        points: [
          '2.1. Показатели Инцидента и способы их достижения. Показатели модели зрелости инцидента И11',
          '2.2. Сценарии внедрения ИИ, направленных на обработку изображений',
          '2.3. Сценарии внедрения ИИ, направленных на расшифровку данных ЭМК.',
        ],
      },
      {
        id: 3,
        title: 'Основы разработки ИИ решений и валидации ИИ решений на основе машинного обучения',
        icon: faLaptopCode,
        points: [
          '3.1. Архитектура ИИ-систем и основы ML',
          '3.2. Основы разработки ИИ решений и валидации ИИ решений на основе машинного обучения',
          '3.3. Безопасность, тестирование и валидация ИИ',
          '3.4. Информационная безопасность',
        ],
      },
    ],
  },
];
